module.exports = __webpack_public_path__ + "img/icon_reduce.72cce8bc.png";